import format from 'date-fns/format';

import { dateFnsLocales } from '../dateFnsLocales';

const formatOptions = { locale: dateFnsLocales.getLocale('en') };

const toDate = (date: string): string =>
  format(new Date(date), 'yyyy-MM-dd', formatOptions);

const toDateTimeLocal = (date: string): string =>
  format(new Date(date), "yyyy-MM-dd'T'HH:mm", formatOptions);

const toDateTimeWithTimezone = (date: string): string =>
  format(new Date(date), "yyyy-MM-dd'T'HH:mm:ssxxx", formatOptions);

const toCustomFormatDate = (customFormat: string, date: string): string =>
  format(new Date(date), customFormat, formatOptions);

const toDateTimeWithCustomLocale = (
  date: string,
  customLocale: string
): string =>
  format(new Date(date), "yyyy-MM-dd'T'HH:mm:ssxxx", {
    locale: dateFnsLocales.getLocale(customLocale)
  });

export default {
  toDateTimeLocal,
  toDateTimeWithTimezone,
  toDate,
  toCustomFormatDate,
  toDateTimeWithCustomLocale
};
